export default "__VITE_ASSET__SaDYzLZE__"